import { Link } from "react-router-dom";
import { Building2, MapPin, Phone, FileText, Shield, MessageCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function LegalFooter() {
  const { user } = useAuth();
  return (
    <footer
      data-testid="legal-footer"
      className="mt-24 border-t border-white/5 bg-black/60"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Quienes somos */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Building2 className="w-4 h-4 text-neon-cyan" />
              <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-neon-cyan">
                QUIÉNES SOMOS
              </div>
            </div>
            <h4 className="font-heading font-bold text-lg leading-tight mb-1">
              Marketing de Inteligencia Artificial
            </h4>
            <p className="text-sm text-muted-foreground">S de RL de CV</p>
          </div>

          {/* Domicilio */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <MapPin className="w-4 h-4 text-neon-gold" />
              <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-neon-gold">
                DOMICILIO
              </div>
            </div>
            <p className="text-sm text-white/85 leading-relaxed">
              Av. Américas 1545, pisos 20, 21, 22 y 23<br />
              Colonia Providencia<br />
              Guadalajara, Jalisco, México
            </p>
          </div>

          {/* Contacto */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Phone className="w-4 h-4 text-neon-red" />
              <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-neon-red">
                CONTACTO
              </div>
            </div>
            <a
              href="https://wa.me/523342802102"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366]/10 border border-[#25D366]/40 text-[#25D366] font-mono text-sm hover:bg-[#25D366]/20 transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp: 33 4280 2102
            </a>

            {/* Admin access */}
            <div className="mt-4">
              {user?.is_admin ? (
                <Link
                  to="/admin"
                  data-testid="footer-admin-panel-link"
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-neon-cyan/10 border border-neon-cyan/40 text-neon-cyan text-xs font-mono uppercase tracking-widest hover:bg-neon-cyan/20 transition-colors"
                >
                  <Shield className="w-3.5 h-3.5" /> Panel Admin
                </Link>
              ) : (
                <Link
                  to="/admin"
                  data-testid="footer-admin-login-link"
                  className="inline-flex items-center gap-2 text-[11px] font-mono text-muted-foreground hover:text-neon-cyan uppercase tracking-[0.25em] transition-colors"
                >
                  <Shield className="w-3 h-3" /> Acceso Admin
                </Link>
              )}
            </div>
          </div>
        </div>

        {/* Legal links */}
        <div className="flex flex-wrap items-center justify-between gap-4 pt-6 border-t border-white/5">
          <div className="flex flex-wrap gap-3">
            <Link
              to="/terminos"
              data-testid="footer-terms-link"
              className="inline-flex items-center gap-1.5 text-xs font-mono text-muted-foreground hover:text-neon-cyan uppercase tracking-widest transition-colors"
            >
              <FileText className="w-3 h-3" />
              Términos y Condiciones
            </Link>
            <span className="text-white/20">·</span>
            <Link
              to="/privacidad"
              data-testid="footer-privacy-link"
              className="inline-flex items-center gap-1.5 text-xs font-mono text-muted-foreground hover:text-neon-cyan uppercase tracking-widest transition-colors"
            >
              <Shield className="w-3 h-3" />
              Aviso de Privacidad
            </Link>
          </div>
          <p className="text-[10px] font-mono text-white/30 uppercase tracking-widest">
            © {new Date().getFullYear()} FameWar · Todos los derechos reservados
          </p>
        </div>
      </div>
    </footer>
  );
}
